module.exports = __webpack_public_path__ + "static/img/101260.38618978.png";